/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import isUndefined from 'lodash.isundefined';
import {translate} from '@ion/core/src/locale/locale';
import {GenericObject} from '@ion/core/src/types/entities';

export interface NotificationMenuWrapperType {
  checkboxesEnabled: boolean;
  onMarkAllAsRead?: () => void;
  onSeeUnreadOnly?: () => void;
  onSelectMultiple?: () => void;
  onMarkSelectedAsRead?: () => void;
  onClearSelected?: () => void;
  setCheckboxesEnabled?: () => void;
  onExport?: () => void;
  onFilter?: () => void;
  onReset?: () => void;
  onSubAccount?: () => void;
  children: JSX.Element;
  omittedMenuItems?: GenericObject;
  filterUnread?: boolean;
  customFilter?: boolean;
  isSubAccount?: boolean;
}

export interface NotificationMenu {
  menuItems: {
    title: string;
    handleClick: () => void;
    selected: boolean;
    key: string;
  }[];
  checkboxItems: {
    title: string;
    handleClick: () => void;
    selected: boolean;
  }[];
}

export const NotificationMenu = ({
  checkboxesEnabled,
  onMarkAllAsRead,
  onSeeUnreadOnly,
  onSelectMultiple,
  onMarkSelectedAsRead,
  onClearSelected,
  setCheckboxesEnabled,
  onExport,
  onFilter,
  onReset,
  children,
  onSubAccount,
  omittedMenuItems,
  isSubAccount = false,
  filterUnread = false,
  customFilter = false
}: NotificationMenuWrapperType) => {
  const menu: NotificationMenu = {
    menuItems : [
      {
        title       : translate('notifications:panel.menu.markAllRead'),
        handleClick : onMarkAllAsRead,
        selected    : false,
        key         : 'MarkAllRead'
      },
      {
        title       : translate('notifications:panel.menu.seeUnreadOnly'),
        handleClick : onSeeUnreadOnly,
        selected    : filterUnread,
        key         : 'SeeUnreadOnly'
      },
      {
        title       : translate('notifications:panel.menu.selectMultiple'),
        handleClick : onSelectMultiple,
        selected    : checkboxesEnabled,
        key         : 'SelectMultiple'
      },
      {
        title       : translate('notifications:panel.menu.export'),
        handleClick : onExport,
        selected    : false,
        key         : 'Export'
      },
      {
        title       : translate('notifications:panel.menu.filter'),
        handleClick : onFilter,
        selected    : customFilter,
        key         : 'Filter'
      },
      {
        title       : translate('notifications:panel.menu.includeSubAccount'),
        handleClick : onSubAccount,
        selected    : isSubAccount,
        key         : 'IncludeSubAccount'
      },
      {
        title       : translate('notifications:panel.menu.reset'),
        handleClick : onReset,
        selected    : false,
        key         : 'Reset'
      }
    ],
    checkboxItems : [
      {
        title       : translate('notifications:panel.menu.markSelectedRead'),
        handleClick : onMarkSelectedAsRead,
        selected    : false
      },
      {
        title       : translate('notifications:panel.menu.clearSelected'),
        handleClick : onClearSelected,
        selected    : false
      }
    ]
  };

  if (!isUndefined(omittedMenuItems)) {
    menu.menuItems = menu.menuItems.filter(({key}) => !omittedMenuItems[key]);
  }

  return (
    <>
      {React.cloneElement(children, {
        menuItems : checkboxesEnabled
          ? [...menu.menuItems, ...menu.checkboxItems]
          : menu.menuItems,
        setCheckboxesEnabled
      })}
    </>
  );
};

export default NotificationMenu;
